/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Site_Url_Error_Site_Daily_LimitInputs */

const en_site_url_error_site_daily_limit = /** @type {(inputs: Site_Url_Error_Site_Daily_LimitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You reached today's website dissection limit for your plan. Try again tomorrow or upgrade.`)
};

const id_site_url_error_site_daily_limit = /** @type {(inputs: Site_Url_Error_Site_Daily_LimitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Batas bedah harian tercapai untuk paketmu. Coba lagi besok atau upgrade.`)
};

/**
* | output |
* | --- |
* | "You reached today's website dissection limit for your plan. Try again tomorrow or upgrade." |
*
* @param {Site_Url_Error_Site_Daily_LimitInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const site_url_error_site_daily_limit = /** @type {((inputs?: Site_Url_Error_Site_Daily_LimitInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Site_Url_Error_Site_Daily_LimitInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_site_url_error_site_daily_limit(inputs)
	return en_site_url_error_site_daily_limit(inputs)
});